import React from 'react';
import CardList from '../components/CardsList';

const TelaDetalhe = ({ dataDetalhada, dataProbabilidadeInternacao, tipoSelecionado, abrirCard, selecionarPaciente }) => {

  const cardSelecionado = CardList.find(c => c.tipo === tipoSelecionado);
  const dataPacientes = dataDetalhada?.[tipoSelecionado];	

  const detalheInfantil = cardSelecionado?.detalhe({
    dataPacientes,
    tipoSelecionado,
    ps_tipo: 'infantil',
    selecionarPaciente,
    dataProbabilidadeInternacao
  });

  const detalheAdulto = cardSelecionado?.detalhe({
    dataPacientes,
    tipoSelecionado,
    ps_tipo: 'adulto',
    selecionarPaciente,
    dataProbabilidadeInternacao
  });

  return (
    <>
      <div className='row'>
        <div className='col-md-3' style={{ width: '17%' }}>
          <div className='card-list'>
            {CardList.map((item) => (
              <div key={item.tipo} className={'card-list-tipo ' + (tipoSelecionado === item.tipo ? 'onSelect' : '')} onClick={() => abrirCard(item.tipo)}>
                {item.titleShort}
                {<img src="/img/icon_arrow_right_2.svg" alt="InsightCare" />}
              </div>
            ))}
          </div>
        </div>
        <div className='col-md-9 card-table' style={{ width: '83%' }}>
          <>
            {detalheAdulto}
            {detalheInfantil}
          </>
        </div>
      </div>
    </>
  );
};

export default TelaDetalhe;